module.exports = __webpack_public_path__ + "static/media/Celular_terminal.a318a17e.png";